export const showKeyList = {
  showKey: ["companyName","prjName","details","advantage"],
  editKey: ["service_id", "img","companyName","prjName","details","advantage"]
};


export const xxx = "xxx";
